var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mimeType.split('/')[0] == 'image')?_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('CIcon',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:('Visualizar'),expression:"'Visualizar'"}],attrs:{"name":"cil-magnifying-glass","placement":"top"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }